import React from 'react';
import PropTypes from 'prop-types';
// import LottieLoader from '../lottie/LottieLoader';


const Loader = (props) => {
  const { isOverlay, auLoader } = props;
  const classname = auLoader || 'h-100';
  return (
    <React.Fragment>
      {
        isOverlay ? (
          <section className="overlay-loader-container position-fixed" data-testid="loader-element">
            <section className={`d-flex justify-content-center ${classname}`}>
              <section className="align-self-center pb-5" role="status">
                <div className="spinner-border-lg text-primary mt-5">
                  <span className="sr-only">Loading...</span>
                </div>
              </section>
            </section>
          </section>
        ) : (
          <section className="container-fluid loader-container" data-testid="loader-element">
            <section className={`d-flex justify-content-center ${classname}`}>
              <section className="align-self-center" role="status">
                <div className="spinner-border-lg text-primary">
                  <span className="sr-only">Loading...</span>
                </div>
              </section>
            </section>
          </section>
        )
      }
    </React.Fragment>

  );
};

Loader.propTypes = {
  isOverlay: PropTypes.bool,
  auLoader: PropTypes.string,
};

Loader.defaultProps = {
  isOverlay: false,
  auLoader: '',
};

export default Loader;
